import * as R from 'ramda'

import constants from 'config/constants'
import { priceAmount, priceInterval } from 'libs/billing/price'

const planName = (name) => ({
  unpaid: 'Expired',
  past_due: 'Past due',
  canceled: 'Canceled',
  trialing: name,
  active: name,
  undefined: 'Expired',
})

export const getPlanName = (subscription) => {
  const status = R.path(['status'], subscription)
  const name = R.path(['plan', 'nickname'], subscription)
  return planName(name)[status]
}

export const getPlanPricing = (subscription) => {
  const status = R.path(['status'], subscription)
  const isActive = constants.activeSubscriptionStatus.includes(status)
  if (isActive) {
    const plan = subscription.plan
    return `$${priceAmount(plan)}/${priceInterval(plan)}`
  }

  return 'feedback withheld'
}

export const formatNumber = (amount) =>
  Number.isInteger(+amount)
    ? parseFloat(amount).toLocaleString('en-US')
    : parseFloat(amount).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })

export const formatPricingWithCoupon = (amount, coupon) =>
  coupon.amount_off
    ? formatNumber(amount - coupon.amount_off)
    : formatNumber(Math.round(amount * (1 - coupon.percent_off / 100) * 100) / 100)

export function getCouponTerm(coupon) {
  return getAmount(coupon) + ' ' + getDuration(coupon)
}

function getAmount(coupon) {
  if (coupon.percent_off) {
    return `${coupon.percent_off}% off`
  }
  return `$${Number(coupon.amount_off)} off`
}

function getDuration(coupon) {
  if (coupon.duration === 'repeating') {
    if (coupon.duration_in_months === 1) {
      return 'for 1 month'
    }
    return `for ${coupon.duration_in_months} months`
  }
  return coupon.duration
}

/**
 * @typedef Charge
 * @property {string} failure_message
 * @property {Outcome} outcome
 * @property {boolean} paid
 *
 * @typedef Outcome
 * @property {string} reason
 */

/**
 * @param {Charge} charge
 * @returns {string}
 */
export function getReasonFailedMessage(charge) {
  if (charge.paid) {
    return ''
  }

  const defaultMessage = 'The card has been declined for an unknown reason.'

  const declineCode = R.path(['reason', 'outcome'], charge)
  if (declineCode === 'do_not_honor') {
    return defaultMessage
  }

  return charge.failure_message || defaultMessage
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/Billing/utils/index.js